import { DestroyRef, inject, Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { takeWhile, timer } from 'rxjs';
import { UserFacade } from '../../store/user/user.facade';
import { hasContactItems } from '@shared/utils/manager-warehouse-fallback';

// While a self-registered user still has no personal manager, the manager block shows the
// branch (warehouse) contacts. Poll /me so it silently swaps to the manager assigned in 1C.
const MANAGER_REFETCH_INTERVAL_MS = 5 * 60 * 1000;

@Injectable({
  providedIn: 'root',
})
export class ManagerContactsRefetchService {
  readonly #userFacade = inject(UserFacade);
  readonly #destroyRef = inject(DestroyRef);

  startManagerContactsRefetch(): void {
    timer(MANAGER_REFETCH_INTERVAL_MS, MANAGER_REFETCH_INTERVAL_MS)
      .pipe(
        // Stop as soon as a personal manager is assigned; getMe writes to the store, so the block reacts.
        takeWhile(() => this.#isManagerMissing()),
        takeUntilDestroyed(this.#destroyRef),
      )
      .subscribe(() => this.#userFacade.getUser());
  }

  #isManagerMissing(): boolean {
    const manager = this.#userFacade.$user()?.manager;

    return !manager || (!manager.name?.trim() && !hasContactItems(manager.phones) && !hasContactItems(manager.emails));
  }
}
